module.exports = __webpack_public_path__ + "img/adhonai.462a790c.svg";